import { Button, Checkbox, Col, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";

import { useLayout } from "../../../../context/LayoutContext";
import { useSendMail } from "./hooks/mail.hooks";

import { useState } from "react";
import { CloudflareAuth, CustomMessage, Title } from "../../../../components";
import styles from "./style.module.scss";
import "./style.scss";

const ContactSection = () => {
  const { getPadding } = useLayout();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { mutate: sendMail } = useSendMail();
  const [cloudflareToken, setCloudflareToken] = useState<string>("");

  const onFinish = async (values: {
    name: string;
    phone: string;
    email: string;
    service: string[];
    remark: string;
  }) => {
    if (!cloudflareToken && process.env.REACT_APP_LOGIN_CLOUDFLARE_KEY) {
      CustomMessage({
        content: (
          <text style={{ fontSize: "14px" }}>{t("form.cloudflare.error")}</text>
        ),
        type: "error",
      });
      return;
    }
    const _services = values.service.join(",");
    await sendMail(
      {
        params: {
          ...values,
          service: _services,
          cf_turnstile_response: cloudflareToken,
        },
      },
      {
        onSuccess: (res: any) => {
          CustomMessage({
            content: (
              <text style={{ fontSize: "14px" }}>
                {t("contact.form.success")}
              </text>
            ),
            type: "success",
          });
          form.resetFields();
        },
        onError: (error: any) => {
          console.debug(error);
        },
      }
    );
  };
  return (
    <div
      className={styles.contactContainer}
      id="contact"
      style={{ paddingLeft: getPadding(), paddingRight: getPadding() }}
    >
      <Title
        text={t("contact.title")}
        shadowText={t("contact.shadow")}
        containerStyle={styles.contactTitleContainer}
        titleStyle={styles.contactTitle}
        shadowStyle={styles.contactTitleShadow}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        className={`contact-form ${styles.contactForm}`}
        // style={{ maxWidth: "800px", margin: "auto", padding: "20px" }}
      >
        {/* Name, Phone, Email */}
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            <Form.Item
              name="name"
              label={t("contact.form.name")}
              rules={[
                {
                  required: true,
                  message: t("form.required", { name: t("contact.form.name") }),
                },
              ]}
            >
              <Input placeholder={t("contact.hint.name")} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              name="phone"
              label={t("contact.form.telephone")}
              rules={[
                {
                  required: true,
                  message: t("form.required", {
                    name: t("contact.form.telephone"),
                  }),
                },
              ]}
            >
              <Input placeholder={t("contact.hint.telephone")} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              name="email"
              label={t("contact.form.mailbox")}
              rules={[
                {
                  required: true,
                  message: t("form.required", {
                    name: t("contact.form.mailbox"),
                  }),
                },
                { type: "email", message: t("form.email.error") },
              ]}
            >
              <Input placeholder={t("contact.hint.mailbox")} />
            </Form.Item>
          </Col>
        </Row>

        {/* Reason with Checkboxes */}
        <Form.Item
          name="service"
          label={t("contact.form.needs")}
          rules={[
            {
              required: true,
              message: t("form.required", { name: t("contact.form.needs") }),
            },
          ]}
        >
          <Checkbox.Group style={{ width: "100%" }}>
            <Row gutter={[16, 16]}>
              <Col xs={24} lg={8}>
                <Checkbox
                  value={t("contact.form.needs.opt1")}
                  style={{ width: "100%" }}
                >
                  {t("contact.form.needs.opt1")}
                </Checkbox>
              </Col>
              <Col xs={24} lg={8}>
                <Checkbox
                  value={t("contact.form.needs.opt2")}
                  style={{ width: "100%" }}
                >
                  {t("contact.form.needs.opt2")}
                </Checkbox>
              </Col>
              <Col xs={24} lg={8}>
                <Checkbox
                  value={t("contact.form.needs.opt3")}
                  style={{ width: "100%" }}
                >
                  {t("contact.form.needs.opt3")}
                </Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>

        {/* Remark */}
        <Row>
          <Col span={24}>
            <Form.Item
              name="remark"
              label={t("contact.form.remark")}
              rules={[
                {
                  required: true,
                  message: t("form.required", {
                    name: t("contact.form.remark"),
                  }),
                },
              ]}
            >
              <Input.TextArea rows={4} placeholder={t("contact.hint.remark")} />
            </Form.Item>
          </Col>
        </Row>

        {/* Submit Button */}
        <Row>
          <Col span={24} className={styles.buttonContainer}>
            <CloudflareAuth
              theme={"light"}
              setCloudflareToken={setCloudflareToken}
            />
            <Button className={styles.button} htmlType="submit">
              {t("contact.form.submit")}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ContactSection;
